module.exports = __webpack_public_path__ + "static/media/tfllogo (1).f98d8efd.png";